/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import '@airglow/prefab-form';

import prefabFactory from '@airglow/prefab';
import { showCreate } from '../../casing/data/prefabs';
import saveSessionSaga from '../save.session.saga';
import { createSessionStepIndex, saving } from './prefabs';

const resetAction = action => () => action;

const prefabs = prefabFactory({
  createForm: {
    type: 'form',
    autocorrect: 'immediate',
    whenToValidate: 'submit',
    fields: {
      link: { type: 'text', fieldName: 'urlField', regex: /[a-zA-Z][a-zA-Z\d+-.]*:\/\/.*/, required: true },
      name: { type: 'text', max: 100, required: true }
    },
    resetActions: [
      resetAction(showCreate.closeAction),
      resetAction(createSessionStepIndex.resetAction)
    ],
    resetOnSuccess: false,
    submitSaga: saveSessionSaga,
    validAction: () => saving.setAction
  }
});

export const { createForm } = prefabs;

export default prefabs;
